const API_FIRST_PAGE = 1
const UI_FIRST_PAGE = 0

export const toApiPage = (uiPage: number) => {
  return uiPage + API_FIRST_PAGE
}

export const toUiPage = (apiPage: number) => {
  return Math.max(apiPage - API_FIRST_PAGE, UI_FIRST_PAGE)
}
